"use strict";

exports.__esModule = true;
exports.shouldLoadAuth = exports.importAuthComponent = void 0;

var _react = require("react");

const shouldLoadAuth = () => process.env.GATSBY_LOGIN_REGISTER_ENABLED === 'true' && ['l3', 'l4'].includes(process.env.GATSBY_CONTENTSTACK_LEVEL);

exports.shouldLoadAuth = shouldLoadAuth;

const importAuthComponent = (factory, fun = c => ({
  // @ts-ignore
  default: c.default
}), fallback = _react.Fragment) => shouldLoadAuth() ? /*#__PURE__*/(0, _react.lazy)(() => factory().then(fun)) : fallback;

exports.importAuthComponent = importAuthComponent;